import { ItemForBrandReq, ItemsDropDownDto, ItemSubCategoryDropDownDto, SubCatReqForCategoryId } from '@gtpl/shared-models/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Button, Card, Col, Form, Input, InputNumber, Radio, Row, Select, Table } from 'antd'
import { FormInstance } from 'rc-field-form';
import React, { useEffect, useState } from 'react';
import { OperationService, ProductionInventoryService } from '@gtpl/shared-services/production';
import { ColumnProps } from 'antd/lib/table';
import { OperationTypeEnum, spsaOperationEnum, spsaPrevOperationEnum } from '@gtpl/shared-models/common-models';

interface AddlotCodeFormProps{
  lotData: (lotItemDto: any[]) => void;
  operation:string
  form:FormInstance<any>
  totalQuantity:(totalQuantity:any) =>void
  visibletable:boolean;
    selectedProdInvId : number;
  prevOperation : string

}
export default function AddlotCodeForm(props:AddlotCodeFormProps){
const { Option } = Select
const [childform] = Form.useForm();
const [tableData, setTableData] = useState<any[]>([]);
const [lotInfo,setLotInfo] = useState<any[]>([])
const operationservice = new OperationService();

// useEffect(() =>{
//   console.log(props.operation);
//   if(props.operation){
//     childform.resetFields();
//     getLotNumbersDropDownForLotClub(props.operation);
//   }
// },[props.operation])

// useEffect(() => {
//   if(props.selectedProdInvId){
//     getLotNumbersDropDownForLotClub(props.operation)
//   }
// },[props.selectedProdInvId])


useEffect(() =>{
  let totalQuantity = 0
  if(tableData.length > 0){
    // tableData.forEach(item =>{totalQuantity +=Number(item.quantity) ? Number(item.quantity):0})
    // console.log(totalQuantity)
    // props.totalQuantity(totalQuantity)
     tableData.forEach(item =>{totalQuantity +=Number(item.clubbedQuantity) ? Number(item.clubbedQuantity):0})
    props.totalQuantity(totalQuantity)
  }
},[tableData])


  const columns: ColumnProps<any>[] = [
    {
      title:'Previous Operation',
      dataIndex:'prevOperation'
    },
    {
      title:'Operation',
      dataIndex:'operation'
    },
 {
      title: 'Lot Code',
      dataIndex: 'lotCodesAvailable',
    },
    // {
    //   title: 'Lot Code',
    //   dataIndex: 'lotCodesAvailable',
    // },
    {
      title: 'Product',
      dataIndex: 'productName',
    },
    {
      title:'Count Type',
      dataIndex:'countType',
      render:(text,record) => {
        return(<>{record.countType ?? '-'}</>)
      }
    },
    {
      title:'Count',
      dataIndex:'count',
       render:(text,record) => {
        return(<>{record.count ?? '-'}</>)
      }
    },
    {
      title: 'Available Quantity ',
      dataIndex: 'quantity',
    },
     {
      title: 'Quantity to Club',
      dataIndex: 'clubbedQuantity',
    },
    // {
    //   title:'O/P Boxes',
    //   dataIndex:'opBoxes',

    // },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text, rowData: any, index) => {
        return(
        <Button size='small' shape='round' type='primary' onClick={() => { deletelot(index) }} >Delete</Button>
        )
      }
    }

  ];

  const saveitems = ( ) =>{   
     childform.validateFields().then(res =>{
      // const obj = {subLotNumber:res.subLotNumber,lotcode : res.lotCodesAvailable,quantity:res.quantity,opBoxes:res.opBoxes}
      console.log(res)
      setTableData((prev) => {return [...prev,res]})
      console.log(tableData)
        childform.resetFields()
        props.lotData([...tableData,res])
        props.visibletable === true;
     })
  }

  const deletelot = (index) =>{
    tableData.splice(index,1)
    setTableData([...tableData])
    props.lotData([...tableData])
    console.log(tableData)
  }

    const getLotNumbersDropDownForLotClub = (value) => {
      operationservice.getLotNumbersDropDownForLotClub({operation:value,plant: Number(localStorage.getItem('unit_id')),prevOperation:childform.getFieldValue('prevOperation')}).then((res) => {
        if (res.status) {
          // setLotInfo(res.data);
            setLotInfo(res.data.filter(e => e.prod_inv_id != props.selectedProdInvId));

        } else {
          setLotInfo([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setLotInfo([]);
      });
  
    }
    const subLotOnchange = (e,option) => {
      const lotNumber = lotInfo.filter((el) => {return el.prod_inv_id == e})
      console.log (lotNumber)
      childform.setFieldsValue({lotCodesAvailable:lotNumber[0]?.lotNumber,opBoxes:lotNumber[0]?.opBoxes,quantity:lotNumber[0]?.quantity,lotNumber:option?.lotNumber,count:option?.count,year:option?.year,product:option?.product,productName:option?.productName,countType:option?.countType})
      // physicalquantity(lotNumber[0].lotNumber);
    }

    const operationOnChange = (value) =>{
      // console.log(value)
      // getInventoryInfo();
      // beHeadingForm.resetFields(['soItemId','mainlotNo','saleOrderId'])
      getLotNumbersDropDownForLotClub(value)
    }

    return(
        <Card title={<span style={{ color: 'white' }}>Add Lots For Clubbing</span>}
        style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
        <Form form={childform} layout={'vertical'}  
        // onFinish={saveitems}
        >
          <Row gutter={24}>
            <Form.Item name='lotNumber' hidden>
              <Input/>
            </Form.Item>
            <Form.Item name='count' hidden>
              <Input/>
            </Form.Item>
            <Form.Item name='year' hidden>
              <Input/>
            </Form.Item>
             <Form.Item name='product' hidden>
              <Input/>
            </Form.Item>
            <Form.Item name='countType' hidden>
              <Input/>
            </Form.Item>
            <Form.Item name='productName' hidden>
              <Input/>
            </Form.Item>
            <Col span={4}>
              <Form.Item
                name="prevOperation"
                label="Previous Operation"
                rules={[{ required: true, message: 'Missing From details' }]}

              >
                <Select
                  placeholder="Select Previous Operation"
                  allowClear
                  showSearch
                  style={{ width: '100%' }}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >{Object.values(spsaPrevOperationEnum).map(value =>{
                  return <Option value={value}>{value}</Option>
                })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
            <Form.Item
                name="operation"
                label="Operation"
                rules={[{ required: true, message: 'Missing From details' }]}

              >
                <Select
                  placeholder="Select Operation"
                  allowClear
                  showSearch
                  style={{ width: '100%' }}
                  onChange={operationOnChange}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >{Object.values(spsaOperationEnum).map(value =>{
                  return <Option value={value}>{value}</Option>
                })}
                </Select>
              </Form.Item>
            </Col>
          <Col span={7}>
            <Form.Item
              name="subLotNumber"
              label="Lot codes Available"
              rules={[
                {
                  required: true,
                  message: 'Lot code is required'
                }
              ]}

            >
              <Select
                showSearch
                optionFilterProp="children"
                // filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select LotCode"
                allowClear
                onChange={(e,option) =>{subLotOnchange(e,option)}}
              >
                 {/* <Option key={0} value={null}>Please select Lot</Option> */}
                    {lotInfo.map((dropData) => {
                      return (
                        <Option
                          key={dropData.prod_inv_id}
                          value={dropData.prod_inv_id}
                          lotNumber={dropData.subLotNumber}
                          count={ dropData.output_grade}
                          year = {dropData.year}
                          product = {dropData.outProductId}
                          countType={dropData.out_count_type}
                          productName= {dropData.outProduct}
                          >
                          {dropData.lotNumber}-{dropData.year}-{dropData.outProduct}{dropData.out_count_type ? `-${dropData.out_count_type}` : ''}{dropData.output_grade ? `-${dropData.output_grade}` : ''}
                        </Option>
                      );
                    })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={7} hidden>
          <Form.Item
              name="lotCodesAvailable"
              label="Lot code "
              rules={[
                {
                  required: true,
                  message: 'Lot codes Available is required'
                }
              ]}

            >
            <Input disabled/>
            </Form.Item>
            </Col>
          <Col span={4}>
              <Form.Item
                  label="Available Quantity"
                  name="quantity"
                  rules={[{ required: true, message: 'Missing quantity' }
                  ]}
                >
                  <Input type='number' style={{ width: '100%' } } disabled
                  //  onChange={e => appendInputData(e.target.value, 'quantity')}
                   />
                </Form.Item>
              </Col>
              <Col span={3}>
              <Form.Item
                  label="Quantity to Club"
                  name="clubbedQuantity"
                  rules={[{ required: true, message: 'Missing quantity' }
                  ]}
                >
                  <Input type='number' style={{ width: '100%' } }
                  //  onChange={e => appendInputData(e.target.value, 'quantity')}
                   />
                </Form.Item>
              </Col>
              <Col span={4} hidden>
              <Form.Item
                  label="O/P Boxes"
                  name="opBoxes"
                  rules={[{ required: true, message: 'Missing opBoxes' }
                  ]}
                  initialValue={0}
                >
                  <Input type='number' style={{ width: '100%' }} disabled defaultValue={0}
                   />
                </Form.Item>
              </Col>
              <Col span={2}>
              <Button style={{ backgroundColor: "#67b32d", color: "white", marginTop: "28px" }} type="primary" onClick={saveitems}>
               ADD
              </Button>
          </Col>
          </Row>
          <br />
          {tableData.length ?
          <Row>
            <Table   rowKey={(row) => row.lotCodesAvailable }        
               scroll={{ y: 1600 }}
              dataSource={tableData}
              columns={columns} 
              pagination={false}
              style={{display : props.visibletable === false ? 'none' : 'block'}}
              /> 
          </Row>:<></>
          }
            </Form>                
            </Card>
    )
}